export default "__VITE_ASSET__BgA$XIdX__"